import React, { useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Layout from './Layout';
import Home from './Home';


export default function HomeContainer({ loggedInUser }) {
    const [selectedMenuData, setSelectedMenuData] = useState({ selectedMenu: '', selectedOn: new Date() });

    function handleNavigationClick(selectedMenu) {
        setSelectedMenuData({ selectedMenu, selectedOn: new Date() });
    }

    let stormwaterNavItems = [
        { path: "b2r", name: "B2R", iconClass: "dhicon-multi-house" },
        /*{ path: "stormwater", name: "Stormwater", iconClass: "dhicon-site2" },*/
    ];

    return (
        <Layout
            navigationItems={stormwaterNavItems}
            onNavigationClick={handleNavigationClick}
            selectedMenu={selectedMenuData.selectedMenu}>
            <Routes>
                <Route path='/*' element={<Home />} />
            </Routes>
        </Layout>);
}
